var BreadcrumbItem = function (props) { return props.children || null; };
export default BreadcrumbItem;
